
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[locale]/account/offers",
      function () {
        return require("private-next-pages/[locale]/account/offers.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[locale]/account/offers"])
      });
    }
  